
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/extraCurricular",
      function () {
        return require("private-next-pages/school/extraCurricular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/extraCurricular"])
      });
    }
  